function showUp(dom){
    gsap.from(dom,{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:dom,
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
        }
    })
}

function autoPlayOnView(className, threshold = 0.5) {
    const elements = $(className).get();
  
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.play();
          observer.unobserve(entry.target); // 播放一次后取消观察
        }
      });
    }, { threshold });
  
    elements.forEach(el => observer.observe(el));
}

var wFlag=window.innerWidth>750

$(()=>{
    
    var country = getCookie('user_country');
    if(country != 'US'){
        window.location.href = 'https://www.oxbar.com/pages/maglink'
    }

    if(!wFlag){
        $('.box1_video').attr('controls','true')
    }

    //box2
    showUp('.box2_title')
    ScrollTrigger.create({
        trigger:'.box2_items',
        start:'top bottom-=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        // markers:true,
        animation:gsap.timeline()
            .from('.box2_items div',{opacity:0,y:'2rem',stagger:0.2})
    })

    //box12
    showUp('.box12 div')

    //box8
    showUp('.box8_img')
    // 获取根元素的字体大小
    let rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);

    var ng_flag=true,intId = [],lineNum=16*rootFontSize
    if(!wFlag){
        lineNum=5.5*rootFontSize
    }

    function letGo() {
        loop(0,".num-con1")
        loop(1,".num-con2")
        loop(2,".num-con3")
    }

    function loop(idx, element) {
        intId[idx] = setInterval(function () {
            $(element).animate({
                'top': '-=50'
            }, 0, function () {
                var s = Math.abs(parseInt($(this).css("top")));
                if (s >= lineNum*10) {
                    $(this).find("ul").slice(0, 1).appendTo($(this));
                    $(this).css("top", 0);
                }
            });
        }, 1)
    }

    function stopGo() {
        clearInterval(intId[0])
        clearInterval(intId[1])
        clearInterval(intId[2])

        var num1 = [-(lineNum * 10), -(lineNum * 11), -(lineNum * 12), -(lineNum * 13), -(lineNum * 14), -(lineNum * 15), -(lineNum * 16), -(lineNum * 17), -(lineNum * 18), -(lineNum * 19),][5];//在这里随机
        var num2 = [-(lineNum * 10), -(lineNum * 11), -(lineNum * 12), -(lineNum * 13), -(lineNum * 14), -(lineNum * 15), -(lineNum * 16), -(lineNum * 17), -(lineNum * 18), -(lineNum * 19),][0];
        var num3 = [-(lineNum * 10), -(lineNum * 11), -(lineNum * 12), -(lineNum * 13), -(lineNum * 14), -(lineNum * 15), -(lineNum * 16), -(lineNum * 17), -(lineNum * 18), -(lineNum * 19),][0];

        pubAnimate(".num-con1", num1)
        pubAnimate(".num-con2", num2)
        pubAnimate(".num-con3", num3)
    }

    function pubAnimate(el,num) {
        $(el).animate({ "top": 0 }, 0, "linear", function () {
            $(this).css("top", 0).animate({ "top": num }, 0, "linear");
        });
    }

    ScrollTrigger.create({
        trigger:'.box8',
        start:'top top+=40%',
        end:'+=0%',
        //markers:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
            if(index>10){
                // 执行一次
                if(ng_flag){
                    letGo();
                    ng_flag=false
                    setTimeout(() => {
                        stopGo();
                    }, 800);
                }
            }
        }
    })

    //box3
    ScrollTrigger.create({
        trigger:'.box3_',
        start:'top center',
        end:'+=0%',
        //toggleActions:'play none none reverse',
        // markers:true,
        animation:gsap.timeline()
            .from('.box3_img',{y:'-130%'})
    })

    
    //box4
    var $video = $('.box4 video');
    if(wFlag){

        ScrollTrigger.create({
            trigger:'.box3_',
            start:'top top+=8%',
            end:'+=40%',
            scrub:1,
            // markers:true,
            animation:gsap.timeline()
                .to('.box3_img1',{x:'-210%',opacity:0})
                .to('.box3_img2',{x:'210%',opacity:0},'<')
                .from('.box3_mask',{scale:0},'<')
                .to({},{duration:0.2})
        })

        ScrollTrigger.create({
            trigger:'.box3_',
            start:'top+=60% top+=8%',
            end:'+=40%',
            scrub:1,
            // markers:true,
            animation:gsap.timeline()
                .to('.box3_title',{opacity:0,duration:0.1})
                .to('.box3',{background:'none',duration:0.1})
                .to('.box3_flag',{transform: "scale(50) translate(-2.5%, -5%)",duration:0.8},'-=10%')
        })

        ScrollTrigger.create({
            trigger:'.box3_',
            start:'top+=90% top+=8%',
            end:'+=100%',
            scrub:true,
            // markers:true,
            onUpdate: function (self) {
                //$video[0].duration
                $video[0].currentTime = self.progress * 1;
            }
        })

        ScrollTrigger.create({
            trigger:'.box3_',
            start:'top top+=8%',
            end:'+=200%',
            pin:true,
        })
    }else{
        ScrollTrigger.create({
            trigger:'.box3_',
            start:'top top+=8%',
            end:'+=40%',
            scrub:1,
            pin:true,
            // markers:true,
            animation:gsap.timeline()
                .to('.box3_img1',{x:'-210%',opacity:0})
                .to('.box3_img2',{x:'210%',opacity:0},'<')
                .from('.box3_title div',{scale:0},'<')
                .to({},{duration:0.2})
        })

        $video.attr('autoplay','true')
        //autoPlayOnView('.box4 video')
    }


    //box5
    showUp('.box5_title')
    ScrollTrigger.create({
        trigger:'.box5',
        start:wFlag?'top center-=20%':'top center',
        end:'+=0%',
        toggleActions:'play none none reverse',
        // markers:true,
        animation:gsap.timeline()
            .from('.box5_bg',{x:'-76%'})
            .to('.box5_bg',{scale:1})
    })

    ScrollTrigger.create({
        trigger:'.box5',
        start:wFlag?'top top+=2%':'top top+=30%',
        end:'+=40%',
        pin:wFlag,
        // markers:true,
        animation:gsap.timeline()
            .to('.box5_line',{opacity:1})
            .to('.box5_line',{x:wFlag?'58rem':'28rem',duration:0.9})
            .to('.box5_light',{opacity:0})
    })

    //box6
    var json1 = {x:'-30%'}
    var json2 = {x:'30%'}
    if(!wFlag){
        json1 = {y:'-40%'}
        json2 = {y:'30%'}
    }
    ScrollTrigger.create({
        trigger:'.box6',
        start:'top center-=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        // markers:true,
        animation:gsap.timeline()
            .to('.box6_img1',json1)
            .to('.box6_img2',json2,'<')
            .from('.box6_img3',{scale:0},'<')
    })

    //box7
    ScrollTrigger.create({
        trigger:'.box7',
        start:'top top+=8%',
        end:'+=60%',
        scrub:1,
        pin:true,
        // markers:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
            $('.box7_text div:nth-child(2)').toggleClass('opacity1',index>50)
        },
        animation:gsap.timeline()
            .to('.box7_item',{x:wFlag?'-27%':'-51%'})
    })

    //box9 box10
    showUp('.box9_img')
    showUp('.box9_title')
    showUp('.box10_img')
    showUp('.box10_title')

    //box11
    new Swiper('.box11Swiper', {
        autoplay: true,
        slidesPerView: wFlag?2:1,
        centeredSlides: true,
    })

    //flavorsSwiper
    new Swiper('.flavorsSwiper', {
        slidesPerView:wFlag?3:1.5,
        centeredSlides: true,
        autoplay:true,
        navigation: {
            nextEl: '.flavorsSwiper-button-next',
            prevEl: '.flavorsSwiper-button-prev',
        }
    })

    //flavors specs package
    showUp('.flavors_title')
    showUp('.specs_img')
    showUp('.package_title')
})